<template>
  <div class="cb_question" :key="lang">
    <span class="cb_sim_question">{{ question }}</span>
    <p class="cb_sim_question">{{ description_short }}</p>
    <p class="cb_sim_question" v-if="question_tag == 'exit'">
      {{ description_long }}
    </p>
    <form v-if="question_tag != 'exit'">
      <input type="text" class="hidden" />
      <div v-if="question_type != 'choice'">
        <input
          v-if="question_type == 'string'"
          type="text"
          v-model="answer"
          class="cb_sim_form-text"
          @change="changeAnswer"
        />
        <input
          v-if="question_type == 'boolean'"
          type="checkbox"
          v-model="answer"
          class="cb_sim_checkbox"
          @change="changeAnswer"
        />
        <div v-if="question_type == 'date'">
          <div class="cb_sim_number-spinner">
            <label for="day-date-of-birth">{{ t("Day") }}</label>
            <div class="number-spinner__input">
              <input
                min="1"
                max="31"
                pattern="[0-9]*"
                type="number"
                class="day-date-of-birth cb_sim_form-number"
                name="day_date_of_birth"
                v-model="day"
                step="1"
              />
            </div>
          </div>
          <div class="cb_sim_number-spinner">
            <label for="month-date-of-birth">{{ t("Month") }}</label>
            <div class="number-spinner__input">
              <input
                min="1"
                max="12"
                pattern="[0-9]*"
                type="number"
                class="month-date-of-birth cb_sim_form-number"
                name="year_date_of_birth"
                v-model="month"
                step="1"
              />
            </div>
          </div>
          <div class="cb_sim_number-spinner">
            <label for="year-date-of-birth">{{ t("Year") }}</label>
            <div class="number-spinner__input">
              <input
                pattern="[0-9]*"
                min="1990"
                max="2099"
                type="number"
                class="year-date-of-birth cb_sim_form-number_year"
                name="year_date_of_birth"
                v-model="year"
                step="1"
              />
            </div>
          </div>
        </div>
      </div>

      <div v-if="question_type == 'choice'">
        <div
          class="cb_sim_radio_container_top"
          v-for="panswer in possible_answers"
          :key="panswer"
        >
          <label class="cb_sim_radio_container">
            {{ translateAnswer(panswer) }}
            <input
              type="radio"
              name="group"
              :value="panswer"
              v-model="answer"
              @change="changeAnswer"
            />
            <span class="cb_sim_radio_checkmark"></span>
          </label>
        </div>
      </div>
    </form>
    <div class="cb_sim_questionbuttons">
      <!-- <span
        v-if="state != 'start'"
        class="cb_sim_link cb_sim_previous"
        @click="previousStep()"
        >{{ t("previous") }}</span
      > -->
      <div class="btn cb_sim_btn_blue cb_sim_next" @click="nextStep()">
        {{ t("next") }}
      </div>
    </div>
  </div>
</template>

<script>
import { loadcockpit } from "@/components/mixins/mixins";
import Datepicker from "vuejs-datepicker";

export default {
  name: "questionStep",
  components: {
    Datepicker,
  },
  mixins: [loadcockpit],
  props: {
    question_tag: String,
    question: String,
    description_short: String,
    description_long: String,
    possible_answers: Array,
    question_type: String,
    given_answer: String,
    state: String,
    translationAnswers: Object,
  },
  data: function () {
    return { answer: null, day: null, month: null, year: null };
  },
  mounted: function () {
    this.answer = this.given_answer;
  },
  watch: {
    given_answer: function (newVal, oldVal) {
      this.answer = newVal;
    },
  },
  methods: {
    translateAnswer: function (key) {
      try {
        if (key in this.translationAnswers[this.lang]) {
          return this.translationAnswers[this.lang][key];
        } else {
          return key;
        }
      } catch (e) {
        return key;
      }
    },
    beforeUpate: function () {
      this.answer = this.given_answer;
    },

    changeAnswer: function (data) {
      this.answer = data.target.value;
    },
    previousStep: function () {
      this.answer = null;
      this.$emit("previousStep");
    },
    nextStep: function () {
      if (this.question_type == "date") {
        this.answer = this.year + "-" + this.month + "-" + this.day;
      }
      if (this.answer) {
        if (this.question_type == "date") {
          if (this.year < 1990 || this.year > 2030) {
            alert(this.t("The year is out of range"));
            return;
          }
          var a = this.year + "-" + this.month + "-" + this.day;
          this.answer = a;
          this.$emit("nextStep", {
            question_tag: this.question_tag,
            answer: a,
          });
        } else if (this.question_type == "boolean") {
          if (this.answer == "on") {
            var a = "Ja";
          } else {
            var a = "Nee";
          }
          this.$emit("nextStep", {
            question_tag: this.question_tag,
            answer: a,
          });
        } else {
          this.$emit("nextStep", {
            question_tag: this.question_tag,
            answer: this.answer,
          });
        }
        this.answer = null;
      }
    },
    dateFormatter(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/*.btn:hover {
  cursor: pointer;
}
*/

.cb_sim_number-spinner {
  display: inline-block;
}
.cb_sim_form-number {
  width: 6rem;
  display: inline-block;
  margin-right: 1.5rem;
}

.cb_sim_form-number_year {
  width: 9rem;
  display: inline-block;
  margin-right: 1.5rem;
}

.cb_sim_form-number,
.cb_sim_form-number_year {
  appearance: none;
  outline: none;
  color: #423132;
  padding: 1rem 2rem 0.9rem;
  background-color: #e3e8f2;
  border: 0.2rem solid #e3e8f2;
  border-radius: 2.45rem;
  font-size: 1.6rem;
  font-weight: 700;
  line-height: 1.1875;
  box-shadow: none;
}

.cb_sim_form-text {
  width: calc(100% - 4rem);
  appearance: none;
  outline: none;
  padding: 1rem 2rem 0.9rem;
  background-color: #e3e8f2;
  border: 0.2rem solid #e3e8f2;
  border-radius: 2.45rem;
  -webkit-box-shadow: none;
  box-shadow: none;
  font-size: 1.6rem;
  font-weight: 700;
  line-height: 1.1875;
  color: #423132;
  transition: border-color 0.2s ease-out, background-color 0.2s ease-out;
  margin: 0;
}

.hidden {
  display: none;
}
.cb_sim_link {
  color: #2c7794;
  cursor: pointer;
}
.cb_sim_btn_blue {
  font-family: "Museo Sans", Helvetica, Arial, sans-serif;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -webkit-box-direction: normal;
  box-sizing: border-box;
  text-decoration: none;
  display: inline-block;
  background-color: #2c7794;
  color: #fff;
  padding: 1.1rem 4rem 1rem 2rem;
  background-image: url("../assets/icons/icon__arrow--yellow.svg");
  background-repeat: no-repeat;
  background-position: right 1.5rem center;
  background-size: 1rem 1.7rem;
  font-size: 1.6rem;
  font-weight: bold;
  line-height: 1.9rem;
  text-align: center;
  border: 0;
  border-radius: 2.45rem;
  margin-top: 0.5rem;
  transition: background-color 0.2s ease-in-out;
}
.cb_sim_question {
  font-family: "Museo Sans", Helvetica, Arial, sans-serif;
  font-size: 1.6rem;
  font-weight: normal;
  line-height: 1.625;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  box-sizing: border-box;
  display: block;
  margin-bottom: 0.5rem;
  padding-left: 1rem;
  color: #423132;
  text-align: left;
}

.cb_sim_radio_container_top {
  overflow: hidden;
  position: relative;
  width: 100%;
  min-height: 5rem;
  margin-bottom: 0.75rem;
  background: #e3e8f2;
  border-radius: 2rem;
  /* padding-top: 2rem; */
}
.cb_sim_radio_container {
  display: block;
  position: relative;
  cursor: pointer;

  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  top: 50%;
  color: #423132;
  font-size: 1.6rem;
  padding-right: 1rem;
  padding-left: 6rem;
  padding-bottom: 2.5rem;
  padding-top: 2.5rem;
  font-weight: 700;
  border-radius: 2rem;
}

/* Hide the browser's default radio button */
.cb_sim_radio_container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  top: 50%;
  margin-top: -1.5rem;
  width: 3rem;
  height: 3rem;
  background: transparent;
  border: none;
  outline: none;
}

/* Create a custom radio button */
.cb_sim_radio_checkmark {
  position: absolute;

  border-radius: 50%;
  left: 1.5rem;
  height: 2.7rem;
  width: 2.7rem;
  border-radius: 0.5rem;
  background: #ffff;
  margin-top: -1.35rem;
  top: 50%;
}

/* On mouse-over, add a grey background color */
.cb_sim_radio_container:hover input ~ .cb_sim_radio_checkmark {
  background-color: #ccc;
}

/* When the radio button is checked, add a blue background */
.cb_sim_radio_container input:checked ~ .cb_sim_radio_checkmark {
  background-color: #2c7794;
}

/* Create the indicator (the dot/circle - hidden when not checked) */
.cb_sim_radio_checkmark:after {
  position: absolute;
  display: none;
}

/* Show the indicator (dot/circle) when checked */
.cb_sim_radio_container input:checked ~ .cb_sim_radio_checkmark:after {
  display: block;
}

/* Style the indicator (dot/circle) */
.cb_sim_radio_container .cb_sim_radio_checkmark:after {
  top: 9px;
  left: 9px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: white;
}

.cb_sim_questionbuttons {
  bottom: 0;
  right: 0;
}
.cb_sim_btn_blue {
  font-family: "Museo Sans", Helvetica, Arial, sans-serif;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -webkit-box-direction: normal;
  box-sizing: border-box;
  text-decoration: none;
  display: inline-block;
  background-color: #2c7794;
  color: #fff;
  padding: 1.1rem 4rem 1rem 2rem;
  background-image: url("../assets/icons/icon__arrow--yellow.svg");
  background-repeat: no-repeat;
  background-position: right 1.5rem center;
  background-size: 1rem 1.7rem;
  font-size: 1.6rem;
  font-weight: bold;
  line-height: 1.9rem;
  text-align: center;
  border: 0;
  border-radius: 2.45rem;
  margin-top: 0.5rem;
  transition: background-color 0.2s ease-in-out;
  cursor: pointer;
}

.cb_question {
  position: relative;
}

.cb_sim_next {
  right: 0;
  position: absolute;
}
.cb_sim_previous {
  position: absolute;
  right: 0;
  margin-right: 15rem;
  margin-top: 1rem;
}
</style>
